$ = require 'jquery'
Singleton = require '../../pattern/singleton'
Elements = require './elements'

module.exports =
class RecruitDetail extends Singleton

  selector         : '.section-recruit'
  detailSelector   : '.lower-container'
  containerSelector: '.recruit-container'

  constructor: ->
    super

    @$window = Elements.$window
      .one 'pagesLoaded', @onPagesLoaded
      .on
        'detailOpenBefore.recruit': @onDetailOpenBefore
        'detailCloseAfter.recruit': @onDetailCloseAfter

  onPagesLoaded: =>
    @$section   = $ @selector
    @$detail    = @$section.find @detailSelector
    @$container = @$detail.find @containerSelector

  onDetailOpenBefore: (e, target) =>
    $ "##{target}"
      .css 'display', 'block'

  onDetailCloseAfter: =>
    @$container.css 'display', 'none'




// WEBPACK FOOTER //
// ./webpack/requires/pc/views/recruit-detail.coffee